
import * as R from 'ramda';
import moment from 'moment-timezone';
import { matchPath } from 'react-router';
import { push as pushAction } from 'connected-react-router';
import { takeLatest, select, put, delay } from 'redux-saga/effects';
import queryString from 'query-string';
import { account as accountApis, assetsLanding as assetsLandingApis } from '../../../../api.js';
import { apiSaga } from '../../../../root-sagas.js';
import docCookie from '../../../../utils/docCookie.js';

function* onLocationChange({ payload }) {
  const pathname = R.path(['location', 'pathname'], payload);
  const search = R.path(['location', 'search'], payload);
  if (pathname === '/generative-ai-sign-up/CleverCompose') {
    yield put(pushAction('/generative-ai-sign-up/emailAssist'));
  }
  const genAiProduct = R.path(
    ['params', 'genAiProduct'],
    matchPath(pathname, {
      path: '/generative-ai-sign-up/:genAiProduct',
      exact: true,
      strict: true
    }));
  if (genAiProduct) {
    yield put({ type: 'generativeAiSignUp_onLoad', payload: { genAiProduct } });
  }
  if (R.pathOr('', ['location', 'search'], payload).indexOf('showMeetingSchedules') > -1) {
    yield put({ type: 'generativeAiSignUp_openMeetingSchedules' });
  }
  if (pathname && pathname.indexOf('generative-ai/addin-installation') > -1) {
    try {
      const query = queryString.parse(search || '');
      if (query.hashToken) {
        // queryString.parse automatically decodes URL-encoded values
        sessionStorage.setItem('hashtoken', query.hashToken);
        yield put({ type: 'AL_INIT', payload: query });
        yield apiSaga('AL_retrieveTokenPayload', assetsLandingApis.retrieveTokenPayload, [
          query.hashToken
        ]);
      } else {
        // No hashToken - still initialize AL state but don't call API
        yield put({ type: 'AL_INIT', payload: query });
      }
    } catch (error) {
      // Error parsing query string or processing hashToken
      if (window.Rollbar) {
        window.Rollbar.error('Error processing generative-ai/addin-installation route', {
          error,
          pathname,
          search
        });
      }
    }
  }
}

function* doSignUp({ type }) {
  const store = yield select(state => state.generativeAiSignUp);
  const payload = R.pick(['email',
    'password',
    'firstName',
    'lastName',
    'companyName',
    'dateFormat',
    'emailClient',
    'companyId',
    'userId',
    'genAiProduct',
  ], store);
  let referral;
  if (docCookie.getItem('rewardful.referral')) {
    try {
      const referralObj = JSON.parse(docCookie.getItem('rewardful.referral'));
      referral = referralObj.id;
    } catch (err) {
      // Silently fail - referral is optional
      if (process.env.NODE_ENV === 'development') {
        console.log('error in parsing referral cookie', err);
      }
    }
  }
  yield apiSaga(type, accountApis.signUpGenerativeAiUser, [{
    ...payload,
    referral,
    region: moment.tz.guess(),
  }]);
}

function* doEmailCheck({ type }) {
  const { email } = yield select(state => state.generativeAiSignUp);
  yield apiSaga(type, accountApis.decryptEmail, [{ email }]);
}

function* signUpSuccess() {
  const { autoLoginLink } = yield select(state => state.generativeAiSignUp);
  if (autoLoginLink) {
    yield put({
      type: 'generativeAiSignUp_successMessage',
      payload: 'One moment please, we are logging you in right now...'
    });
    yield delay(4000);
    window.location.assign(autoLoginLink);
  } else {
    yield put({
      type: 'generativeAiSignUp_successMessage',
      payload: `We have sent you an email with a link to automatically log in. Please check your inbox.`
    });
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  takeLatest('@@router/LOCATION_CHANGE', onLocationChange),
  takeLatest('generativeAiSignUp_doSignUp', doSignUp),
  takeLatest('generativeAiSignUp_doEmailCheck', doEmailCheck),
  takeLatest('generativeAiSignUp_doSignUp_SUCCESS', signUpSuccess),
];
